import React, { useEffect } from "react";

import LoadingOrbit from "../../../components/LoadingOrbit";

import RiskFinancingPortfolioTab from "./RiskFinancingPortfolioTab";
import RiskFinancingHeader from "../../../components/risk_financing/layout/RiskFinancingHeader";
import RiskFinancingTabs from "../../../components/risk_financing/layout/RiskFinancingTabs";
import RiskFinancingCoverageTab from "./RiskFinancingCoverageTab";
import RiskFinancingScenarioTab from "./RiskFinancingScenarioTab";
import RiskFinancingDecisionAnalysisTab from "./RiskFinancingDecisionAnalysisTab";

import useRiskFinancingContext from "../context/useRiskFinancingContext";
import { useHelpContext } from "../../../help/HelpContext";


export default function RiskFinancingContent({
  embedded = false,
  settings,
  settingsLoaded = true,
  settingsError = null,
}) {
  const riskFinancingEngine =
    useRiskFinancingContext();
  const { setCurrentViewId } = useHelpContext();

  console.log(
    "### RF CONTENT CONTEXT ###",
    {
      portfolioData:
        riskFinancingEngine.portfolio?.data,

      portfolioSummary:
        riskFinancingEngine.portfolio?.summary,

      decisionAnalysis:
        riskFinancingEngine.decisionAnalysis?.analysis,

      status:
        riskFinancingEngine.status,
    }
  );

  const {
    status,
    navigation,
  } = riskFinancingEngine;

  const {
    initialLoading,
  } = status;

  const {
    activeTab,
    setActiveTab,
  } = navigation;

  useEffect(() => {
    setCurrentViewId(activeTab);
    return () => setCurrentViewId(null);
  }, [activeTab, setCurrentViewId]);

  let content;

  if (settingsError) {
    content = (
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-800">
          Unable to load Platform Settings.
        </div>
    );
  } else if (!settingsLoaded || initialLoading) {
    content = (
      <div className={embedded ? "flex min-h-64 items-center justify-center" : ""}>
        <LoadingOrbit />
      </div>
    );
  }

  return (
    <div
      className={
        embedded
          ? "space-y-6"
          : "space-y-6 p-6"
      }
    >
      {!embedded && (
        <RiskFinancingHeader
          settings={settings}
        />
      )}

      {!settingsError && settingsLoaded && (
        <RiskFinancingTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      )}

      {content}

      {!content && activeTab === "portfolio" && (
        <RiskFinancingPortfolioTab
          settings={settings}
        />
      )}

      {!content && activeTab === "scenario" && (
        <RiskFinancingScenarioTab
          settings={settings}
        />
      )}

      {!content && activeTab === "coverage" && (
        <RiskFinancingCoverageTab
          settings={settings}
        />
      )}

      {!content && activeTab === "decision_analysis" && (
        <RiskFinancingDecisionAnalysisTab
          settings={settings}
        />
      )}
    </div>
  );
}
